export const qep = () => ({
  init() {
    const self = this;

    const qepSearch = self.GetSearchTermElement();
    if (qepSearch) {
      qepSearch.addEventListener('keyup', function (e) {
        self.QepSearchByFilter(1);
      });
    }

    const searchCategoryCheckboxes = this.nodeListToArray(
      this.GetSearchOnElement(),
    );
    const searchYearCheckboxes = this.nodeListToArray(
      this.GetSearchYearElement(),
    );

    searchYearCheckboxes.forEach((element, index, array) => {
      element.addEventListener('change', e => {
        self.QepSearchByFilter(1);
      });
    });

    searchCategoryCheckboxes.forEach((element, index, array) => {
      element.addEventListener('change', e => {
        self.QepSearchByFilter(1);
      });
    });

    initPaging(self);
  },

  QepSearch(searchCategories, searchYears, searchTerm, page) {
    const self = this;
    if (page == 'undefined' || page == '') {
      page = 1;
    }

    let url = window.location.href;
    url =
      url[url.length - 1] === '/' ? url + 'SearchQep/' : url + '/SearchQep/';

    const filterViewModel = {
      Years: searchYears,
      SubjectCategories: searchCategories,
      Query: searchTerm,
      Page: page,
    };

    fetch(url, {
      method: 'Post',
      body: JSON.stringify(filterViewModel),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(res => res.text())
      .then(function (html) {
        document.querySelector('.js-qep-table').innerHTML = html;
        initPaging(self);
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  },

  QepSearchByFilter(page) {
    const searchTerm = this.GetSearchTermElement().value;

    const searchOnValues = this.GetCurrentSearchOnValue(
      this.GetSearchOnElement(),
    );
    const searchYear = this.GetCurrentSearchOnValue(
      this.GetSearchYearElement(),
    );

    this.QepSearch(searchOnValues, searchYear, searchTerm, page);
  },

  GetSearchOnElement() {
    return document.querySelectorAll('.js-searchoninput');
  },

  GetSearchYearElement() {
    return document.querySelectorAll('.js-searchyear');
  },

  GetSearchTermElement() {
    var search = document.getElementById('js-qep-search');
    if (search == null || search == 'undefined') {
      search = '';
    }
    return search;
  },

  GetCurrentSearchOnValue(searchOnElements) {
    var searchOnValues = [];
    searchOnElements.forEach(el => {
      if (el.checked) {
        searchOnValues.push(el.value);
      }
    });

    return searchOnValues;
  },

  nodeListToArray(nodeList) {
    return Array.from(nodeList);
  },
});

function initPaging(self) {
  var previous = document.getElementById('btn_previous');
  if (previous !== null) {
    previous.addEventListener(
      'click',
      function () {
        self.QepSearchByFilter(previous.value);
      },
      false,
    );
  }

  var buttons = document.querySelectorAll('.btn_page');
  for (var i = 0; i < buttons.length; i++) {
    var selff = buttons[i];

    selff.addEventListener(
      'click',
      function () {
        self.QepSearchByFilter(this.value);
      },
      false,
    );
  }

  var next = document.getElementById('btn_next');
  if (next !== null) {
    next.addEventListener(
      'click',
      function () {
        self.QepSearchByFilter(next.value);
      },
      false,
    );
  }
}
